import React from "react";

import { getFileTypeAndIcon } from "../utils";


const Attachment = (props) => {
    const displayFileName = props.displayFileName || false
    const displayBorder = props.displayBorder || true

    const {type, icon} = getFileTypeAndIcon(props.url)

    return (
        <a href={props.url} style={{width: "fit-content"}} target="_blank" rel="noopener noreferrer">
            <div
                className={`flex`}
                style={{
                    border: displayBorder ? "1px solid #dee2e6" : "none",
                    borderRadius: displayBorder ? "5px" : "0",
                    backgroundColor: displayBorder ? "white" : "",
                    width: "fit-content",
                    padding: "5px 7px",
                    maxWidth: "400px"
                }}
            >
                <img src={icon} alt="File Image" className="icon-class" height="45" style={{ cursor: 'pointer' }}/>

                {displayFileName && (
                    <span className="ml-1 mt-1" style={{ fontSize: "12px", color: "#505d74" }}>
                        {props.url.split('/').pop()}
                    </span>
                )}
            </div>
        </a>
    )
}

export default Attachment;